// Generated by tools/icons/generate.mjs. Edit the SVG source and manifest instead.
import * as React from "react"
const ExclamationMarkCircleIcon = /* @__PURE__ */ React.forwardRef<SVGSVGElement, React.ComponentProps<"svg">>(
  (props, ref) => {
    return (
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M12 16.5303C12.5523 16.5303 13 16.978 13 17.5303C13 18.0826 12.5523 18.5303 12 18.5303C11.4477 18.5303 11 18.0826 11 17.5303C11 16.978 11.4477 16.5303 12 16.5303Z"
          fill="currentColor"
        />
        <path
          d="M12 5.55078C12.4142 5.55078 12.75 5.88657 12.75 6.30078V14C12.75 14.4142 12.4142 14.75 12 14.75C11.5858 14.75 11.25 14.4142 11.25 14V6.30078C11.25 5.88657 11.5858 5.55078 12 5.55078Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5Z"
          fill="currentColor"
        />
      </svg>
    )
  }
)
ExclamationMarkCircleIcon.displayName = "ExclamationMarkCircleIcon"
export { ExclamationMarkCircleIcon }
